import {
    CREATE_KNITTING_DC_DETAILS_FAILURE,
    CREATE_KNITTING_DC_DETAILS_REQUEST,
    CREATE_KNITTING_DC_DETAILS_SUCCESS,
    CREATE_USER_FORM_KNITTING_DC_DETAILS,
    DELETE_KNITTING_DC_DETAILS_FAILURE,
    DELETE_KNITTING_DC_DETAILS_REQUEST,
    DELETE_KNITTING_DC_DETAILS_SUCCESS,
    FETCH_SINGLE_KNITTING_DC_DETAILS_FAILURE,
    FETCH_SINGLE_KNITTING_DC_DETAILS_REQUEST,
    FETCH_SINGLE_KNITTING_DC_DETAILS_SUCCESS,
    FETCH_KNITTING_DC_DETAILS_FAILURE,
    FETCH_KNITTING_DC_DETAILS_REQUEST,
    FETCH_KNITTING_DC_DETAILS_SUCCESS,
    KNITTING_DC_DETAILS_USERFORM_RESET,
    UPDATE_KNITTING_DC_DETAILS_FAILURE,
    UPDATE_KNITTING_DC_DETAILS_REQUEST,
    UPDATE_KNITTING_DC_DETAILS_SUCCESS,
    FETCH_KNITTING_DC_DETAILS_BY_ID_REQUEST,
    FETCH_KNITTING_DC_DETAILS_BY_ID_SUCCESS,
    FETCH_KNITTING_DC_PREVIOUS_LIST_REQUEST,
    FETCH_KNITTING_DC_PREVIOUS_LIST_SUCCESS,
    FETCH_KNITTING_DC_PREVIOUS_LIST_FAILURE,
    FETCH_GRN_NO_BY_YARN_PO_REQUEST,
    FETCH_GRN_NO_BY_YARN_PO_FAILURE,
    FETCH_GRN_NO_BY_YARN_PO_SUCCESS,
    FETCH_KNITTING_DC_DETAILS_FABRIC_FROM_STYLE_REQUEST,
    FETCH_KNITTING_DC_DETAILS_FABRIC_FROM_STYLE_SUCCESS,
    FETCH_KNITTING_DC_DETAILS_FABRIC_FROM_STYLE_FAILURE,
    FETCH_KNITTING_DC_DETAILS_DIA_FROM_STYLE_REQUEST,
    FETCH_KNITTING_DC_DETAILS_DIA_FROM_STYLE_SUCCESS,
    FETCH_KNITTING_DC_DETAILS_DIA_FROM_STYLE_FAILURE,
    FETCH_KNITTING_DC_DETAILS_RATE_FROM_STYLE_REQUEST,
    FETCH_KNITTING_DC_DETAILS_RATE_FROM_STYLE_SUCCESS,
    FETCH_KNITTING_DC_DETAILS_RATE_FROM_STYLE_FAILURE,
    KNITTING_FABRIC_DETAILS_GET_REQUEST,
    KNITTING_FABRIC_DETAILS_GET_SUCCESS,
    KNITTING_FABRIC_DETAILS_GET_FAILURE,
    KNITTING_FABRIC_PROGRAM_ID_GET_REQUEST,
    KNITTING_FABRIC_PROGRAM_ID_GET_SUCCESS,
    KNITTING_FABRIC_PROGRAM_ID_GET_FAILURE,
    FETCH_KNITTING_DC_DETAILS_GAGE_FROM_STYLE_SUCCESS,
    FETCH_KNITTING_DC_DETAILS_GAGE_FROM_STYLE_FAILURE,
    FETCH_KNITTING_DC_DETAILS_GAGE_FROM_STYLE_REQUEST,
    FETCH_KNITTING_DC_DETAILS_LOOP_FROM_STYLE_SUCCESS,
    FETCH_KNITTING_DC_DETAILS_LOOP_FROM_STYLE_REQUEST,
    FETCH_KNITTING_DC_DETAILS_LOOP_FROM_STYLE_FAILURE,
    KNITTING_DC_PROGRAM_ID_SUCCESS,
    KNITTING_DC_PROGRAM_ID_REQUEST,
    KNITTING_DC_PROGRAM_ID_FAILURE,
    FETCH_KNITTING_DC_YARN_STOCK_LIST_REQUEST,
    FETCH_KNITTING_DC_YARN_STOCK__LIST_SUCCESS,
    FETCH_KNITTING_DC_YARN_STOCK__LIST_FAILURE,
    SHOW_PREVIOUS_LIST
} from './knittingDCDetails.actionsType';

export const KNITTING_DC_DETAILS = 'knittingDCDetails';

let initialState = {
    loading: false,
    knittingDCDetailsById: [],
    knittingDCDetails: [],
    previousList: [],
    yarnStockList: [],
    grnNoByYarnPO: [],
    knittingDCDetailsFabricFrmStyle: [],
    knittingDCDetailsDiaFrmStyle: [],
    knittingDCDetailsRateFrmStyle: [],
    userform: {
        fldRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldFKBagWeight: 0,
        fldFKNoofBags: 0,
        fldPOQuantity: 0,
        fldInwardQuantity: 0,
        fldDiscountPercentage: 0,
        inwardId: [],
        InwardNO: [],
        fabricdropDownData: []
    },
    selectedKnittingDCDetails: {},
    errorMessage: '',
    iperrorMessage: '',
    fldknittingProgramId: '',
    showPrevious: true
};

export let knittingDCDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_KNITTING_DC_DETAILS_REQUEST:
        case FETCH_KNITTING_DC_DETAILS_FABRIC_FROM_STYLE_REQUEST:
        case FETCH_KNITTING_DC_DETAILS_DIA_FROM_STYLE_REQUEST:
        case FETCH_KNITTING_DC_DETAILS_RATE_FROM_STYLE_REQUEST:
        case FETCH_GRN_NO_BY_YARN_PO_REQUEST:
        case FETCH_KNITTING_DC_PREVIOUS_LIST_REQUEST:
        case FETCH_KNITTING_DC_DETAILS_BY_ID_REQUEST:
        case CREATE_KNITTING_DC_DETAILS_REQUEST:
        case FETCH_SINGLE_KNITTING_DC_DETAILS_REQUEST:
        case UPDATE_KNITTING_DC_DETAILS_REQUEST:
        case DELETE_KNITTING_DC_DETAILS_REQUEST:
        case KNITTING_FABRIC_DETAILS_GET_REQUEST:
        case KNITTING_FABRIC_PROGRAM_ID_GET_REQUEST:
        case FETCH_KNITTING_DC_DETAILS_GAGE_FROM_STYLE_REQUEST:
        case FETCH_KNITTING_DC_DETAILS_LOOP_FROM_STYLE_REQUEST:
        case KNITTING_DC_PROGRAM_ID_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_KNITTING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                knittingDCDetails: updatePayload
            };
        case FETCH_KNITTING_DC_DETAILS_FABRIC_FROM_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                knittingDCDetailsFabricFrmStyle: updatePayload
            };
        case KNITTING_DC_PROGRAM_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                fldFkProgramId: updatePayload.fldFKProgram
            }

        case SHOW_PREVIOUS_LIST:
            return {
                ...state,
                loading: false,
                showPrevious: payload
            }

        case KNITTING_FABRIC_DETAILS_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricdropDownData: updatePayload
            };
        case FETCH_KNITTING_DC_DETAILS_GAGE_FROM_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                gageProgram: updatePayload
            }
        case FETCH_KNITTING_DC_DETAILS_DIA_FROM_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                knittingDCDetailsDiaFrmStyle: updatePayload
            };
        case FETCH_KNITTING_DC_DETAILS_RATE_FROM_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: { ...state.userform, fldRate: updatePayload }
            };
        case FETCH_KNITTING_DC_DETAILS_LOOP_FROM_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                loopProgram: updatePayload
            };
        case FETCH_GRN_NO_BY_YARN_PO_SUCCESS:
            return {
                ...state,
                loading: false,
                grnNoByYarnPO: updatePayload?.Inward
            };
        case FETCH_KNITTING_DC_PREVIOUS_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                previousList: updatePayload?.Program,

            };

        case FETCH_KNITTING_DC_DETAILS_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                knittingDCDetailsById: updatePayload
            };

        case CREATE_KNITTING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKBagWeight: 0,
                    fldFKNoofBags: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0,
                    fldDiscountPercentage: 0,
                    inwardId: [],
                    InwardNO: []
                },
                grnNoByYarnPO: []
            };
        case FETCH_SINGLE_KNITTING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: updatePayload,
                Bags: updatePayload?.fldFKNoofBags
            };
        case UPDATE_KNITTING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedKnittingDCDetails: {},
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKBagWeight: 0,
                    fldFKNoofBags: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0,
                    fldDiscountPercentage: 0,
                    inwardId: [],
                    InwardNO: []
                }
            };
        case DELETE_KNITTING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKBagWeight: 0,
                    fldFKNoofBags: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0,
                    fldDiscountPercentage: 0,
                    inwardId: [],
                    InwardNO: []
                },
                selectedKnittingDCDetails: {},
                isDeleteStatus: updatePayload
            };

        case FETCH_KNITTING_DC_DETAILS_FAILURE:
        case FETCH_KNITTING_DC_DETAILS_FABRIC_FROM_STYLE_FAILURE:
        case FETCH_KNITTING_DC_DETAILS_DIA_FROM_STYLE_FAILURE:
        case FETCH_KNITTING_DC_DETAILS_RATE_FROM_STYLE_FAILURE:
        case FETCH_GRN_NO_BY_YARN_PO_FAILURE:
        case FETCH_KNITTING_DC_PREVIOUS_LIST_FAILURE:
        case FETCH_SINGLE_KNITTING_DC_DETAILS_FAILURE:
        case CREATE_KNITTING_DC_DETAILS_FAILURE:
        case UPDATE_KNITTING_DC_DETAILS_FAILURE:
        case DELETE_KNITTING_DC_DETAILS_FAILURE:
        case KNITTING_FABRIC_DETAILS_GET_FAILURE:
        case KNITTING_FABRIC_PROGRAM_ID_GET_FAILURE:
        case FETCH_KNITTING_DC_DETAILS_GAGE_FROM_STYLE_FAILURE:
        case FETCH_KNITTING_DC_DETAILS_LOOP_FROM_STYLE_FAILURE:
        case KNITTING_DC_PROGRAM_ID_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_KNITTING_DC_DETAILS:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };

        case KNITTING_FABRIC_PROGRAM_ID_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                fldknittingProgramId: updatePayload
            };
        case KNITTING_DC_DETAILS_USERFORM_RESET:
            return {
                ...state,
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKBagWeight: 0,
                    fldFKNoofBags: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0,
                    fldDiscountPercentage: 0,
                    inwardId: [],
                    InwardNO: [],
                    fldFabric: '',
                    fldDia: '',
                    fldGage: '',
                    fldLoopLength: ''
                },
                selectedKnittingDCDetails: {}
            };
        default:
            return state;
    }
};
